import { ChangeEvent, FocusEvent, ReactNode, useEffect, useState } from "react";
import { uniqueId } from "core/utils/StringHelper";

interface InputShadedProps {
  placeholder?: string;
  id?: string;
  label?: string;
  icon?: ReactNode;
  withButton?: boolean;
  onClick?(): void;
  onChange?(value: string): void;
  value?: string;
  inputType?: "text" | "password";
  disabled?: boolean;
  autoComplete?: string;
  onBlur?(event: FocusEvent<HTMLInputElement>): void;
  onFocus?(event: FocusEvent<HTMLInputElement>): void;
  className?: string;
  labelClassName?: string;
}

export default function InputShaded({
  placeholder = "Input Text",
  id = uniqueId("input"),
  label = "Input",
  icon,
  withButton = false,
  onClick,
  onChange,
  value = "",
  inputType = "text",
  disabled = false,
  autoComplete = "off",
  onBlur,
  onFocus,
  className = "",
  labelClassName = "",
}: InputShadedProps) {
  function renderSubField() {
    if (icon) {
      if (withButton) {
        return (
          <button
            className="shaded-input-button"
            type="button"
            onClick={onClick}
          >
            {icon}
          </button>
        );
      }
      return <div className="shaded-input-icon">{icon}</div>;
    }
  }

  const inputClassName = `input-shaded ${className}`;
  const labelClass = `input-shaded-label ${labelClassName}`;

  return (
    <div className="input-shaded-wrapper">
      <label className={labelClass} htmlFor={id}>
        {label}
      </label>
      <div className="input-shaded-text-wrapper">
        {renderSubField()}
        <input
          className={inputClassName}
          id={id}
          placeholder={placeholder}
          onChange={(e) => onChange?.(e.target.value)}
          onBlur={onBlur}
          onFocus={onFocus}
          value={value}
          type={inputType}
          disabled={disabled}
          autoComplete={autoComplete}
        />
      </div>
    </div>
  );
}
